import { fetcher, handleException, handleError, hookDone } from './middleware';
import onion from './onion';
import { addDomain, addToolDomain } from '@/env';
import { getCache, setCache } from './cache-request';
import { filterConditions, formatQueryObj } from '@/common/utils';
import { removeInvalidKey } from './middleware';

const invoker = onion([handleError, handleException, hookDone, fetcher]);

export default async function request(api, options) {
  api = addDomain(api);
  const res = await invoker({ api, options });
  const { body } = res;
  return body;
}

export async function requestTool(api, options) {
  api = addToolDomain(api);
  const res = await invoker({ api, options });
  const { body } = res;
  return body;
}

export async function requestToolGet(api, query = {}, config = {}) {
  if (typeof query === 'string') throw new TypeError('query只能是query对象');
  return await requestTool(api, { query, ...config });
}

export async function requestToolPost(api, data = {}, config = {}) {
  return await requestTool(api, { method: 'POST', body: data, ...config });
}

export async function requestGet(api, query = {}, config = {}) {
  if (typeof query === 'string') throw new TypeError('query只能是query对象');
  return await request(api, { query, ...config });
}

export async function requestGetFilterEmpty(api, query = {}, config = {}) {
  if (typeof query === 'string') throw new TypeError('query只能是query对象');
  const _query = filterConditions(query);
  return await request(api, { query: _query, ...config });
}

export async function requestPost(api, data = {}, config = {}) {
  return await request(api, { method: 'POST', body: data, ...config });
}

// Form表单形式的POST提交方式
export async function requestFormPost(api, data = {}, config = {}) {
  return await request(api, { method: 'POST', body: formatQueryObj(removeInvalidKey(data)), ...config });
}

export async function requestGetCache(api, query = {}, { refresh = false, ...config } = {}) {
  if (typeof query === 'string') throw new TypeError('query只能是query对象');

  let res = !refresh ? getCache(api, { config, query }) : undefined;

  if (res) return res;

  res = await request(api, { query, ...config });

  setCache(api, { config, query }, res);

  return res;
}
